var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/Check';
import clsx from 'clsx';
import { dirStyleGenerator } from '../functions';
var CheckBox = function (_a) {
    var children = _a.children, onChange = _a.onChange, checked = _a.checked, error = _a.error, fontSize = _a.fontSize, readOnly = _a.readOnly, _b = _a.classes, _c = _b === void 0 ? {} : _b, container = _c.container, helperTextClassName = _c.helperText, box = _c.box, checkClass = _c.checkClass, checkIconContainer = _c.checkIconContainer, iconButton = _c.iconButton, inputClasses = __rest(_c, ["container", "helperText", "box", "checkClass", "checkIconContainer", "iconButton"]);
    var _d = useState(checked || false), check = _d[0], setCheck = _d[1];
    var classes = useStyles({ error: error, fontSize: fontSize });
    useEffect(function () {
        if (checked !== undefined)
            setCheck(checked);
    }, [checked]);
    return (_jsxs("div", __assign({ className: clsx(classes.container, container), onClick: function () { return !!!readOnly && setCheck(function (prev) { if (onChange)
            onChange(!prev); return !prev; }); } }, { children: [_jsx(IconButton, __assign({ className: iconButton }, { children: _jsx("div", __assign({ className: clsx(classes.box, box) }, { children: _jsx("div", __assign({ className: clsx(classes.checkIconContainer, check && classes.checked, checkIconContainer) }, { children: _jsx(CheckIcon, { className: clsx(classes.checkIcon, checkClass) }, void 0) }), void 0) }), void 0) }), void 0),
            _jsx("div", __assign({ className: clsx(classes.description, helperTextClassName) }, { children: children }), void 0)] }), void 0));
};
export default CheckBox;
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return ({
        container: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'flex-start',
            marginLeft: -12
        },
        box: (_a = {
                position: 'relative',
                border: "1px solid",
                borderColor: function (props) { return props.error ? theme.palette.error.main : theme.palette.primary.main; },
                borderRadius: 3,
                height: 15,
                width: 15
            },
            _a[theme.breakpoints.down(500)] = {
                height: 20,
                width: 20,
                borderWidth: 1.5
            },
            _a[theme.breakpoints.up(1600)] = {
                height: 20,
                width: 20
            },
            _a),
        checkIconContainer: __assign(__assign({ overflow: 'hidden', position: 'absolute', top: -8 }, dirStyleGenerator('', -2)), { direction: theme.direction, transition: 'width 0.3s ease', width: 0 }),
        checked: (_b = {
                width: 21
            },
            _b[theme.breakpoints.down(500)] = {
                width: 27
            },
            _b[theme.breakpoints.up(1600)] = {
                width: 27
            },
            _b),
        checkIcon: (_c = {
                fill: theme.palette.primary.main
            },
            _c[theme.breakpoints.down(500)] = {
                height: 30,
                width: 30
            },
            _c[theme.breakpoints.up(1600)] = {
                height: 30,
                width: 30
            },
            _c),
        description: (_d = {
                color: function (props) { return props.error ? theme.palette.error.main : theme.palette.primary.main; },
                fontSize: function (props) { var _a; return (_a = props.fontSize) !== null && _a !== void 0 ? _a : 13; },
                maxWidth: 'calc(100% - 15px - 7px)',
                textAlign: 'initial',
                padding: '12px 0',
                margin: '-2px 0 0 7px'
            },
            _d[theme.breakpoints.down(500)] = {
                fontSize: '16px !important',
                maxWidth: 'calc(100% - 20px - 7px)'
            },
            _d[theme.breakpoints.up(1600)] = {
                fontSize: '16px !important',
                maxWidth: 'calc(100% - 20px - 7px)'
            },
            _d)
    });
});
//# sourceMappingURL=CheckBox.js.map